class NavigationState {
  isDrawerOpen: boolean;

  constructor() {
    this.isDrawerOpen = false;
  }
}

export const navigationState = new NavigationState();
